<template>
	<el-dialog title="提示" class="review-detail" top="5vh" :visible.sync="dialogVisible" width="80vw"
		:before-close="close" :close-on-click-modal="false" :lock-scroll="false">
		<div class="dialog-head flex-sb" slot="title">
			<div>参赛作品信息</div>
			<div><i class="el-icon-close"></i></div>
		</div>
		<div class="dialog-content" v-loading="loading">

			<div class="form">
				<div class="info-group flex wrap">
					<div :style="{width:item.width || '33.33%'}"
						v-if="(!item.target || (item.target && content[item.field])) && !item.hide"
						v-for="(item,index) in fieldList" :key="index">
						<div class="cell-title" v-if="item.type === 'title'">
							<div class="til">{{item.title}}</div>
						</div>
						<div class="member" v-else-if="item.type === 'table'">
							<div class="info-label" v-if="item.label" style="padding-bottom: 10px;font-size: 16px;">
								{{item.label}}：
							</div>
							<div class="table">
								<el-table border :data="content[item.field]" style="width: 100%">
									<div v-for="(v,i) in item.column" v-if="!v.hide" :key="i">
										<el-table-column fixed="left" v-if="v.type === 'index'" label="序号"
											align="center" type="index" width="50">
										</el-table-column>
										<el-table-column :width="v.width" v-else-if="v.type !== 'move'" :prop="v.prop" :label="v.label">
										</el-table-column>
										<el-table-column v-else-if="v.type === 'select-school'" :prop="v.prop"
											:label="v.label">
											<template slot-scope="scope">
												{{scope.row.detailField && getValue(content[scope.row.detailField]) || content[scope.row.field] || '-'}}
											</template>
										</el-table-column>
									</div>
								</el-table>
							</div>
						</div>
						<!-- 独立标题附件 -->
						<div v-else-if="item.type === 'upload-independent'">
							<div class="info-label" v-if="item.label">
								{{item.label}}：
							</div>
							<div class="cell-title" v-if="item.title">
								<div class="til">{{item.title}}</div>
							</div>
							<div class="files" v-if="content[item.field] && content[item.field].length">
								<div class="files-item col-center" v-for="(v,i) in content[item.field]" :key="i">
									<div class="icon">
										<img src="../../assets/word.png" alt=""
											v-if="['doc','docx','DOC','DOCX'].includes(getFileExtension(v.name))" />
										<img src="../../assets/pdf.png" alt=""
											v-if="['pdf','PDF'].includes(getFileExtension(v.name))" />
										<img src="../../assets/excel.png" alt=""
											v-if="['xls','xlsx','XLS','XLSX'].includes(getFileExtension(v.name))" />
										<img src="../../assets/ppt.png" alt=""
											v-if="['ppt','pptx','PPT','PPTX'].includes(getFileExtension(v.name))" />
										<img src="../../assets/video.png" alt=""
											v-if="['mp4','mkv','avi','mov','wmv','rmvb','RMVB','flv','FLV','MP4','MKV','AVI','MOV','WMV'].includes(getFileExtension(v.name))" />
										<el-image style="width: 100px; height: 100px" :src="v.download_url"
											:preview-src-list="[v.download_url]"
											v-if="['jpg','jpeg','png','webp'].includes(getFileExtension(v.name))">
										</el-image>
									</div>
									<div class="right"
										v-if="['mp4','mkv','avi','mov','wmv','rmvb','RMVB','flv','FLV','MP4','MKV','AVI','MOV','WMV'].includes(getFileExtension(v.name))"
										@click="openvideo(v.download_url)">
										<div class="name">
											{{v.name}}
										</div>
										<div class="view-video">
											查看视频
										</div>
									</div>
									<div class="right"
										v-if="!['jpg','jpeg','png','webp','mp4','mkv','avi','mov','wmv','rmvb','RMVB','flv','FLV','MP4','MKV','AVI','MOV','WMV'].includes(getFileExtension(v.name))">
										<el-dropdown placement="right" @command="handleCommand($event,v)">
											<div>
												<div class="name" @click="viewFile(v.link_url)">
													{{v.name}}
												</div>
												<div>{{renderSize(v.size)}}</div>
											</div>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item command="download"
													v-if="authority !== 'expert'">下载<span
														style="color: red;margin-left: 0.625rem;">(预览较慢时请选择下载)</span></el-dropdown-item>
												<el-dropdown-item command="view">在线预览</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>
									</div>
								</div>
							</div>
							<div style="padding-bottom:20px;padding-left: 10px;" v-else>暂无附件</div>
						</div>
						<!-- 复合附件 -->
						<div v-else-if="item.type === 'upload-composite'">
							<div class="cell-title" v-if="item.title">
								<div class="til">{{item.title}}</div>
							</div>
							<div v-for="(v,i) in item.composite" :key="i">
								<div class="sub-title" v-if="v.title">{{v.title}}</div>
								<div class="files" style="padding-bottom: 20px;"
									v-if="content[v.field] && content[v.field]">
									<div class="files-item col-center" v-for="(m,n) in content[v.field]" :key="n">
										<div class="icon">
											<img src="../../assets/word.png" alt=""
												v-if="['doc','docx','DOC','DOCX'].includes(getFileExtension(m.name))" />
											<img src="../../assets/pdf.png" alt=""
												v-if="['pdf','PDF'].includes(getFileExtension(m.name))" />
											<img src="../../assets/excel.png" alt=""
												v-if="['xls','xlsx','XLS','XLSX'].includes(getFileExtension(m.name))" />
											<img src="../../assets/ppt.png" alt=""
												v-if="['ppt','pptx','PPT','PPTX'].includes(getFileExtension(m.name))" />
											<img src="../../assets/video.png" alt=""
												v-if="['mp4','mkv','avi','mov','wmv','rmvb','RMVB','flv','FLV','MP4','MKV','AVI','MOV','WMV'].includes(getFileExtension(m.name))" />
											<el-image style="width: 100px; height: 100px" :src="m.download_url"
												:preview-src-list="[m.download_url]"
												v-if="['jpg','jpeg','png','webp'].includes(getFileExtension(m.name))">
											</el-image>
										</div>
										<div class="right "
											v-if="['mp4','mkv','avi','mov','wmv','rmvb','RMVB','flv','FLV','MP4','MKV','AVI','MOV','WMV'].includes(getFileExtension(v.name))"
											@click="openvideo(m.download_url)">
											<div class="name">
												{{m.name}}
											</div>
											<div class="view-video">
												查看视频
											</div>
										</div>
										<div class="right"
											v-if="!['jpg','jpeg','png','webp','mp4','mkv','avi','mov','wmv','rmvb','RMVB','flv','FLV','MP4','MKV','AVI','MOV','WMV'].includes(getFileExtension(v.name))">
											<el-dropdown placement="right" @command="handleCommand($event,m)">
												<div>
													<div class="name" @click="viewFile(m.link_url)">
														{{m.name}}
													</div>
													<div>{{renderSize(m.size)}}</div>
												</div>
												<el-dropdown-menu slot="dropdown">
													<el-dropdown-item command="download"
														v-if="authority !== 'expert'">下载<span
															style="color: red;margin-left: 0.625rem;">(预览较慢时请选择下载)</span></el-dropdown-item>
													<el-dropdown-item command="view">在线预览</el-dropdown-item>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
									</div>
								</div>
								<div style="padding-bottom:20px" v-else>暂无附件</div>
							</div>

						</div>
						<div class="info-item"
							v-else-if="item.type === 'select' || item.type === 'radio' || item.type === 'select-school'">
							<div class="info-label">
								{{item.label}}：
							</div>
							<div class="info-value">
								{{item.detailField && getValue(content[item.detailField]) || content[item.field] || '-'}}
							</div>
						</div>
						<div class="info-item" v-else-if="item.type === 'select-composite'">
							<div class="info-label">
								{{item.label}}：
							</div>
							<div class="info-value col-center">
								<div v-for="(v,i) in item.composite" :key="i">
									<span style="padding: 0 4px;color: #4979ff;"
										v-if="i !== 0">|</span>{{v.detailField && getValue(content[v.detailField]) || content[v.field] || '-'}}
								</div>

							</div>
						</div>
						<div v-else-if="item.type === 'tips'"></div>
						<div v-else class="info-item">
							<div class="info-label">
								{{item.label}}：
							</div>
							<div class="info-value">
								{{content[item.field] || '-'}}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cell-title" style="margin-bottom: 10px;">
				<div class="til">校赛评审结果</div>
			</div>
			<div class="flex">
				<div :class="[['primary','primary','success'][content.school_audit_status]]">
					{{['待评审','待评审','已评审'][content.school_audit_status]}}
				</div>
			</div>
			<div class="cell-title" style="margin-bottom: 10px;">
				<div class="til">省赛评审结果</div>
			</div>
			<div class="flex">
				<div :class="[['primary','primary','success'][content.province_audit_status]]">
					{{['待评审','待评审','已评审'][content.province_audit_status]}}
				</div>
			</div>

			<div class="cell-title" style="margin-bottom: 10px;">
				<div class="til">资格审核</div>
			</div>
			<div class="flex">
				<div :class="[['primary','success','danger','danger'][content.apply_audit_status]]">
					{{['审核中','通过','驳回','省赛驳回'][content.apply_audit_status]}}
				</div>
			</div>
			<div class="review-box" v-if="content.school_review_show == 1">
				<!-- <div class="info-item">
					<div class="info-label">
						校赛评审结果
					</div>
					<div style="padding: 5px 0;font-size: 16px;"
						:class="[['primary','success','danger'][content.school_apply_audit_status]]">
						{{['未评审','评审通过','评审拒绝'][content.school_apply_audit_status]}}
					</div>
				</div> -->
				<div class="info-item">
					<div class="info-label">
						校赛评审意见
					</div>
					<div class="info-value">
						{{content.school_apply_audit_msg || '-'}}
					</div>
				</div>
				<div class="info-item">
					<div class="info-label">
						校赛专家组平均分
					</div>
					<div class="info-value">
						{{content.school_avg_score || '-'}}
					</div>
				</div>
				<div class="info-item">
					<div class="info-label">
						校赛排名
					</div>
					<div class="info-value">
						{{content.school_ranking || '-'}}
					</div>
				</div>
				<div class="info-item">
					<div class="info-label">
						校赛奖项
					</div>
					<div class="flex" style="margin-top: 10px;">
						<div :class="[['-','gold','silver','copper'][content.school_awards]]">
							{{['-','金奖','银奖','铜奖','优秀奖'][content.school_awards]}}
						</div>
					</div>
				</div>
			</div>
			<div class="review-box" v-if="content.province_review_show == 1">
				<!-- <div class="info-item">
					<div class="info-label">
						省赛评审结果
					</div>
					<div style="padding: 5px 0;font-size: 16px;"
						:class="[['primary','success','danger'][content.province_apply_audit_status]]">
						{{['未评审','评审通过','评审拒绝'][content.province_apply_audit_status]}}
					</div>
				</div> -->
				<div class="info-item">
					<div class="info-label">
						省赛评审意见
					</div>
					<div class="info-value">
						{{content.province_apply_audit_msg || '-'}}
					</div>
				</div>
				<div class="info-item">
					<div class="info-label">
						省赛专家组平均分
					</div>
					<div class="info-value">
						{{content.province_avg_score || '-'}}
					</div>
				</div>
				<div class="info-item">
					<div class="info-label">
						省赛排名
					</div>
					<div class="info-value">
						{{content.province_ranking || '-'}}
					</div>
				</div>
				<div class="info-item">
					<div class="info-label">
						省赛奖项
					</div>
					<div class="flex" style="margin-top: 10px;">
						<div :class="[['-','gold','silver','copper'][content.province_awards]]">
							{{['-','金奖','银奖','铜奖','优秀奖'][content.province_awards]}}
						</div>
					</div>
				</div>
			</div>

			<div v-if="authority === 'expert'">
				<div class="review-results" v-if="content.review && content.review.score">
					<!-- <div class="flex">
						<div class="average col-center">
							<div class="label">平均分</div>
							<div class="value">{{content.review.avg_score || '-'}}</div>
						</div>
					</div> -->
					<!-- <div class="table">
						<el-table border :data="tableData2" style="width: 100%">
							<el-table-column prop="name" label="评审专家">
							</el-table-column>
							<el-table-column prop="score" label="评分">
							</el-table-column>
							<el-table-column prop="is_approve" label="是否立项">
								<template slot-scope="scope">
									<span>{{scope.row.is_approve ? '是':'否'}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="comment" label="评价">
							</el-table-column>
						</el-table>
					</div> -->
					<div class="form" style="padding: 0;">
						<div class="info-group flex wrap">
							<div class="info-item col-center">
								<div class="info-label">
									评分：
								</div>
								<div class="info-value">
									{{content.review.score || '-'}}
								</div>
							</div>
							<div class="info-item" style="width: 100%;margin: 0;">
								<div class="info-label">
									评价意见：
								</div>
								<div class="info-value comment-info" style="margin-top: 1.25rem;"
									v-html="content.review.comment || '-'">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<view-doc ref="viewDoc"></view-doc>
		<span slot="footer" class="dialog-footer">
			<el-button @click="close">取 消</el-button>
			<el-button type="primary" v-if="authority === 'expert' && isReview"
				@click="handleReview">{{content.apply_audit_status =='2' || content.apply_audit_status == '3' ? '修改评审' : '评审'}}</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import {
		submitReportDetail,
		submitReportDetailZ
	} from '@/common/api/report.js'
	import viewDoc from './view-doc'
	// 导入字段数据js
	import field from './field-child/field.js'
	export default {
		name: '',
		props: {
			value: {
				type: Boolean,
				default: false
			},
			isReview: {
				type: Boolean,
				default: true
			}
		},
		components: {
			viewDoc
		},
		watch: {
			value: {
				handler(v) {
					this.dialogVisible = v
				},
				deep: true,
				imediate: true,
			}

		},
		data() {
			return {
				dialogVisible: false,
				loading: true,
				status: 1,
				// 表格相关
				tableData: [],
				// 附件相关
				fileList: [],
				modifiedFileList: [],
				tableData2: [],
				content: {},
				item_apply_id: '',
				formType: '',
				fieldList: [],
				typeIndex: {
					xskc: 1,
					xxkc: 2,
					hhs: 3,
					xnfz: 4,
					shsj: 5,
				}
			}
		},
		created() {},
		mounted() {

		},
		methods: {
			handleReview() {
				this.$emit('handleReview', this.item_apply_id, this.content.audit_status == '2')
			},
			async init(id) {
				this.item_apply_id = id
				this.loading = true;
				try {
					let fun = this.authority === 'expert' ? submitReportDetailZ : submitReportDetail
					const {
						data
					} = await fun({
						item_apply_id: id,
						id: id,
					})
					// data.is_leaflet_audit = 1
					let obj = JSON.parse(JSON.stringify(field))
					if (data.is_leaflet_audit == 1 && this.authority === 'expert') {
						obj.form.forEach((item, index) => {
							if (item.isHide) {
								item.hide = true
							}
							if (item.column && item.column.length) {
								item.column.forEach((v, i) => {
									if (v.isHide) {
										v.hide = true
									}
								})
							}
							if (item.showType === 1) {
								item.hide = true
							}
						})
					} else if (data.is_leaflet_audit == 2 && this.authority === 'expert') {
						obj.form.forEach((item, index) => {
							if (item.showType === 2) {
								item.hide = true
							}
						})
					}
					for (let key in data.team_principal) {
						data['team_principal-' + key] = data.team_principal[key]
					}
					this.fieldList = obj.form
					console.log(this.fieldList)
					this.loading = false;
					this.content = JSON.parse(JSON.stringify(data))
				} catch (e) {
					this.loading = false
					//TODO handle the exception
				}
			},
			close() {
				this.content = {}
				this.item_apply_id = ''
				this.$emit('close')
			},
			// 获取文件后缀
			getFileExtension(fileName) {
				return fileName.slice(fileName.lastIndexOf(".") + 1);
			},
			//格式化文件大小
			renderSize(value) {
				if (null == value || value == '') {
					return "0 Bytes";
				}
				var unitArr = new Array("Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB");
				var index = 0;
				var srcsize = parseFloat(value);
				index = Math.floor(Math.log(srcsize) / Math.log(1024));
				var size = srcsize / Math.pow(1024, index);
				size = size.toFixed(2);
				return size + unitArr[index];
			},
			// 操作菜单
			handleCommand(command, val) {
				if (command === 'download') {
					window.open(val.download_url, '_blank')
				} else {
					this.viewFile(val.link_url)
				}
			},
			// 在线预览
			viewFile(url) {
				console.log(url)
				window.open(url)
				return
				//你的文档地址
				var file = 'http://static.shanhuxueyuan.com/test.pdf';
				// let file = 'http://static.shanhuxueyuan.com/demo/excel.xlsx'
				// let file = 'http://static.shanhuxueyuan.com/test6.docx'
				//XDOC文档预览服务地址
				this.$refs.viewDoc.open(url, (this.authority === 'expert' ? true : false))
				var xurl = "https://view.xdocin.com/view?src=";
				//传入文档地址
				// xurl += encodeURIComponent(file);
				xurl += encodeURIComponent(url);
				//预览参数
				var ops = {
					"pdf": true,
					printable: true,
				};
				if (this.authority === 'expert') {
					ops = {
						"pdf": true,
						printable: false,
						"watermark": "实验教学和教学实验室建设研究"
					}
				}
				//传入预览参数
				for (var a in ops) {
					xurl += "&" + a + "=" + encodeURIComponent(ops[a]);
				}
				//开始预览
				window.open(xurl);
				return
				let onlineViewType = ['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx']
				let fileTypeName = url.substring(url.lastIndexOf('.') + 1, url.length).split('?')[0]
				let isWord = onlineViewType.find((type) => type === fileTypeName)
				if (isWord) {
					url = 'http://view.officeapps.live.com/op/view.aspx?src=' + url
				}
				window.open(url, '_blank')
			},
			// 渲染数据
			getValue(v) {
				if (v instanceof Array) {
					return v.map(m => m.name).join(',')
				} else if (v instanceof Object) {
					return v.name || '-'
				} else {
					return v
				}
			},
			openvideo(url) {
				const routeUrl = this.$router.resolve({
					path: '/viewVideo',
					query: {
						url: encodeURIComponent(url)
					}
				});
				window.open(routeUrl.href, '_blank')
			},
		}

	}
</script>

<style lang="scss" scoped>
	@import url('/quill/dist/quill.core.css');
	@import url('/quill/dist/quill.snow.css');
	@import url('/quill/dist/quill.bubble.css');

	::v-deep .el-dialog__header {
		background-color: #4389DF;
		padding: 1.125rem 1.25rem;
	}

	::v-deep .el-dialog {
		border-radius: 0.625rem;
		overflow: hidden;
	}

	::v-deep .el-table__header tr,
	::v-deep .el-table__header th {
		background-color: #F8F8F8;
	}



	.dialog-head {
		color: white;
	}

	.dialog-content {
		padding: 0 1.25rem;

		.cell-title {
			margin-bottom: 1.875rem;

			.til {
				font-size: 1.25rem;
				color: #000;
				font-weight: 530;
				position: relative;
				padding-left: 1.5rem;
			}

			.til::after {
				content: "";
				display: block;
				width: 0.25rem;
				height: 1rem;
				position: absolute;
				background-color: #4389E0;
				left: 0.625rem;
				top: 50%;
				margin-top: -8px;
			}

		}

		.form {
			padding: 0 0 0.625rem;

			.info-label {
				color: #888;
				flex-shrink: 0;
			}

			.info-group {
				.info-item {
					padding: 0 10px 20px;
					font-size: 1rem;
					padding-right: 10px;
					box-sizing: border-box;



					.info-value {
						color: #000;
						padding-top: 5px;
						border: 1px solid #e2e2e2;
						padding: 10px 10px;
						margin-top: 10px;
						border-radius: 4px;
					}

					.image-prview {
						display: flex;
						flex-wrap: wrap;
						width: 340px;
					}

					.image-prview-item {
						width: 100px;
						margin-bottom: 10px;
					}
				}

				& .info-item:nth-child(3n-1) {
					// margin: 0 1.25rem 1.25rem;
				}

			}
		}

		.table {
			width: 100%;

			::v-deep .cell {
				font-weight: bold;
			}
		}

		.statistics {
			font-size: 1rem;
			padding-left: 1.25rem;
			margin-top: -0.625rem;

			.statistics-item {
				padding-bottom: 1.25rem;
				color: #999;
				margin-right: 1.25rem;

				span {
					color: #4979ff;
					font-weight: bold;
				}
			}
		}

		.member {
			width: 100%;
			border-radius: 0.25rem;
			overflow: hidden;
			margin-bottom: 1.875rem;
			padding: 0 10px;

			.add-member {
				margin-top: 0.625rem;
				border-radius: 4px;
				border: 1px dashed #E3E7EC;
				text-align: center;
				cursor: pointer;
				color: #4389DF;
				text-align: center;
				padding: 1rem;
				font-size: 1rem;
			}
		}

		.files {
			padding: 10px 1.25rem 0 0;

			.files-item {
				padding-bottom: 1.25rem;

				.icon {
					width: 2.5rem;

					img {
						width: 100%;
					}
				}

				.right {
					padding-left: 0.625rem;
					color: #969696;
					font-size: 0.875rem;

					.name {
						font-size: 1rem;
						margin-bottom: 0.3rem;
						color: #4389E0;
						cursor: pointer;
					}

					.name:hover {
						text-decoration: underline;
					}
				}
			}
		}

		.review-results {
			padding: 0 1.25rem;

			.average {
				border-radius: 0.25rem;
				border: 1px solid #E3E7EC;
				color: #4389E0;
				overflow: hidden;

				div {
					width: 5rem;
					height: 3rem;
					text-align: center;
					line-height: 3rem;
				}

				.label {
					background-color: #F8F8F8;
					color: #000;
					border-right: 1px solid #E3E7EC;
					font-size: 1rem;
				}

				.value {
					font-weight: bold;
					font-size: 1.25rem;
				}
			}

			.table {
				padding-top: 1.25rem;
			}
		}
	}

	.research-experience,
	.comment-info {
		width: 100%;
		font-size: 0.875rem;
		color: #333;
		padding: 0 1.25rem;
		padding-bottom: 1.875rem;
		border: 1px solid #e2e2e2;
		border-radius: 4px;
	}

	.primary {
		display: inline-block;
		// background: #F0F7FF;
		padding: 0.375rem 0.875rem;
		color: #4389E0;
		font-size: 1.125rem;
		border-radius: 0.375rem;
		// margin-left: 1.25rem;
	}

	.success {
		display: inline-block;
		padding: 0.375rem 0.875rem;
		// background: #E8FAEB;
		color: #59DB69;
		font-size: 1.125rem;
		border-radius: 0.375rem;
		// margin-left: 1.25rem;
	}

	.warning {
		display: inline-block;
		padding: 0.375rem 0.875rem;
		// background: #f1ece6;
		color: #E6A23C;
		font-size: 1.125rem;
		border-radius: 0.375rem;
		// margin-left: 1.25rem;
	}

	.danger {
		display: inline-block;
		padding: 0.375rem 0.875rem;
		// background: #f1ece6;
		color: #ff0000;
		font-size: 1.125rem;
		border-radius: 0.375rem;
		// margin-left: 1.25rem;
	}

	.sub-title {
		margin-top: -10px;
		font-size: 16px;
		padding-bottom: 20px;
		padding-left: 10px;
		color: #333
	}

	.review-box.gold {
		border: 1px solid rgba(255, 215, 0, .5);
	}

	.review-box.silver {
		border: 1px solid rgba(192, 192, 192, .5);
	}

	.review-box.copper {
		border: 1px solid rgba(184, 115, 51, .5);
	}

	.review-box.excellent {
		border: 1px solid rgba(32, 140, 255, .5);
	}

	.review-box {
		display: flex;
		flex-wrap: wrap;
		padding: 30px;
		border: 1px solid silver;
		margin-top: 20px;
		border-radius: 6px;

		.info-item {
			width: 33.333%;
			padding: 0 10px 10px 0;
			box-sizing: border-box;

			.info-value {
				color: #000;
				margin-top: 10px;
			}

			.gold {
				color: rgb(255, 215, 0);
				padding: 4px 14px;
				border-radius: 4px;
				border: 1px solid rgba(255, 215, 0, .5);
				font-size: 14px;
			}

			.silver {
				color: rgb(192, 192, 192);
				padding: 4px 14px;
				border-radius: 4px;
				border: 1px solid rgba(192, 192, 192, .5);
				font-size: 14px;
			}

			.copper {
				color: rgb(184, 115, 51);
				padding: 4px 14px;
				border-radius: 4px;
				border: 1px solid rgba(184, 115, 51, .5);
				font-size: 14px;
			}

			.excellent {
				color: rgb(32, 140, 255);
				padding: 4px 14px;
				border-radius: 4px;
				border: 1px solid rgba(32, 140, 255, .5);
				font-size: 14px;
			}
		}
	}

	.view-video {
		cursor: pointer;
	}

	.view-video:hover {
		text-decoration: underline;
		color: #4979ff !important;
	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 923px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {}

	@media screen and (max-width: 922px) {

		.review-detail {
			::v-deep .el-form-item {
				width: 100%;
				margin: 0 0 1.25rem;
			}

			::v-deep .el-form .el-form-item:nth-child(3n-1) {
				margin: 0 0 1.25rem;
			}

			.dialog-content {
				padding: 0;

				.cell-title {
					margin-bottom: 1.875rem;

					.til {
						font-size: 1rem;
					}
				}

				.form {
					padding: 0 0.625rem;

					.form-item-textarea {
						width: 100%;
					}

					.info-group {
						.info-item {
							width: 100%;
						}

						& .info-item:nth-child(3n-1) {
							margin: 0 0 1.25rem;
						}
					}
				}

				.member {
					overflow-x: auto;
				}

				.member .table,
				.member .add-member {
					width: 60rem;

				}

				.el-upload__tip {
					width: 100%;
					margin: 1.25rem 0 0.625rem;
				}
			}

			::v-deep {
				.el-dialog__body {}

				.el-dialog {
					width: 100% !important;
					margin-top: 0 !important;
					border-radius: 0 !important;
				}
			}

		}

		.research-experience {
			margin-top: -0.625rem;

			padding-bottom: 1.25rem;
		}
	}
</style>